function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordeonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "25px",
    width: "25px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "transparent"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M371.262,484.631c68.696-34.701,119.632-99.437,135.52-176.959l-94.544-94.544L281.714,328.545 L256,369.371L371.262,484.631z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#b00020"
    },
    points: "256,369.371 99.762,213.128 127.798,185.092 256,313.296 384.202,185.092 412.238,213.13 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#b00020"
    },
    points: "256,313.296 384.202,185.092 412.238,213.13 256,369.371 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordeonArrow);
export default __webpack_public_path__ + "static/media/accordeonArrow.a3f96d864dee5f6157db27609d256433.svg";
export { ForwardRef as ReactComponent };